<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="iq-card mb-0" style="min-width: 300px;">
    <div class="iq-card-header d-flex justify-content-between">
      <div class="iq-header-title">
        <h4 class="card-title" v-if="!data.lndmId">Add New Landmark</h4>
      </div>
    </div>
    <div class="iq-card-body">
      <div class="row mb-3">
        <div role="group" class="form-group col-md-6">
          <label for="lndmName" class="d-block form-label text-left">
            Name:
          </label>
          <div class="bv-no-focus-ring">
            <div role="group" class="input-group">
              <input
                class="form-control"
                type="text"
                id="lndmName"
                placeholder="Landmark Name"
                v-model="data.lndmName"
                :class="errors.lndmName ? 'is-invalid' : ''"
              >
              <b-form-invalid-feedback v-if="errors.lndmName">
                {{ Object.values(errors.lndmName) }}
              </b-form-invalid-feedback>
            </div>
          </div>
        </div>
        <div role="group" class="form-group col-md-6">
          <label for="lndmType" class="d-block form-label text-left">
            Type:
          </label>
          <div class="bv-no-focus-ring">
            <div role="group" class="input-group">
              <select
                class="form-control"
                id="lndmType"
                v-model="data.lndmType"
                :class="errors.lndmType ? 'is-invalid' : ''"
              >
                <option value="">Select Type</option>
                <option value="port">PORT</option>
                <option value="jetty">JETTY</option>
                <option value="sea">SEA</option>
              </select>
              <b-form-invalid-feedback v-if="errors.lndmType">
                {{ Object.values(errors.lndmType) }}
              </b-form-invalid-feedback>
            </div>
          </div>
        </div>
      </div>

      <div class="row mb-3">
        <div role="group" class="form-group col-md-12">
          <label for="lndmDescription" class="d-block form-label text-left">
            Description:
          </label>
          <div class="bv-no-focus-ring">
            <div role="group" class="input-group">
              <textarea
                class="form-control"
                id="lndmDescription"
                rows="3"
                placeholder="Description"
                v-model="data.lndmDescription"
                :class="errors.lndmDescription ? 'is-invalid' : ''"
              ></textarea>
              <b-form-invalid-feedback v-if="errors.lndmDescription">
                {{ Object.values(errors.lndmDescription) }}
              </b-form-invalid-feedback>
            </div>
          </div>
        </div>
      </div>

      <div class="row mb-3">
        <div role="group" class="form-group col-md-6">
          <label for="lndmLatitude" class="d-block form-label text-left">
            Latitude:
          </label>
          <div class="bv-no-focus-ring">
            <div role="group" class="input-group">
              <input
                class="form-control"
                type="text"
                inputmode="decimal"
                id="lndmLatitude"
                placeholder="-6.12345678"
                v-model="data.lndmLatitude"
                @input="onCoordinateTextInput('lat')"
                @blur="onCoordinateBlur('lat')"
                :class="errors.lndmLatitude || coordinateValidationError.lat ? 'is-invalid' : ''"
              >
              <b-form-invalid-feedback v-if="errors.lndmLatitude">
                {{ Object.values(errors.lndmLatitude) }}
              </b-form-invalid-feedback>
              <small v-if="coordinateValidationError.lat" class="text-danger d-block mt-1">
                {{ coordinateValidationError.lat }}
              </small>
            </div>
          </div>
        </div>
        <div role="group" class="form-group col-md-6">
          <label for="lndmLongitude" class="d-block form-label text-left">
            Longitude:
          </label>
          <div class="bv-no-focus-ring">
            <div role="group" class="input-group">
              <input
                class="form-control"
                type="text"
                inputmode="decimal"
                id="lndmLongitude"
                placeholder="106.12345678"
                v-model="data.lndmLongitude"
                @input="onCoordinateTextInput('lng')"
                @blur="onCoordinateBlur('lng')"
                :class="errors.lndmLongitude || coordinateValidationError.lng ? 'is-invalid' : ''"
              >
              <b-form-invalid-feedback v-if="errors.lndmLongitude">
                {{ Object.values(errors.lndmLongitude) }}
              </b-form-invalid-feedback>
              <small v-if="coordinateValidationError.lng" class="text-danger d-block mt-1">
                {{ coordinateValidationError.lng }}
              </small>
            </div>
          </div>
        </div>
      </div>

      <div class="row mb-3">
        <div role="group" class="form-group col-md-12">
          <label class="d-block form-label text-left">
            Search Reference Landmark:
          </label>
          <div class="position-relative">
            <input
              v-model="referenceSearchQuery"
              type="text"
              class="form-control"
              placeholder="Type landmark name to use as map reference"
              @focus="showReferenceDropdown = true"
              @input="onReferenceInput"
              @blur="onReferenceBlur"
            >
            <div
              v-if="showReferenceDropdown && filteredReferenceLandmarks.length > 0"
              class="reference-dropdown"
            >
              <button
                v-for="landmark in filteredReferenceLandmarks"
                :key="landmark.lndmId"
                type="button"
                class="reference-item"
                @mousedown.prevent="selectReferenceLandmark(landmark)"
              >
                {{ landmark.lndmName || '-' }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="row mb-3">
        <div role="group" class="form-group col-md-12">
          <label class="d-block form-label text-left">
            Pick Location:
          </label>
          <div class="text-muted small">Click the map to fill latitude and longitude.</div>
          <div ref="landmarkMap" class="landmark-form-map mt-2"></div>
        </div>
      </div>

      <div class="form-group">
        <b-button
          @click="onCancelAddClicked"
          class="mr-1"
          size="sm"
          :disabled="isSubmit"
          variant="outline-danger"
        >
          <div class="mx-2">Cancel</div>
        </b-button>
        <b-button
          type="submit"
          @click="onSubmitClicked"
          :disabled="isSubmit || !isFormComplete || hasCoordinateRangeError"
          variant="primary"
          size="sm"
          class="ml-1"
        >
          <div class="mx-2">
            <i v-if="isSubmit" class="ri-loader-line"></i>
            Submit
          </div>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-undef */
export default {
  name: 'LandmarkForm',
  props: {
    data: { type: Object, required: true },
    errors: { type: Object, default: () => ({}) },
    isSubmit: { type: Boolean, default: false },
    referenceLandmarks: { type: Array, default: () => [] },
  },
  data() {
    return {
      map: null,
      marker: null,
      markerIcon: null,
      defaultCenter: [-6.2, 106.816666],
      defaultZoom: 5,
      referenceSearchQuery: '',
      showReferenceDropdown: false,
      referenceBlurTimeout: null,
      draftStorageKey: 'landmark_form_draft_v1',
    };
  },
  computed: {
    isCreate() {
      return !this.data.lndmId;
    },
    isFormComplete() {
      const name = (this.data.lndmName || '').trim();
      const type = (this.data.lndmType || '').trim();
      const lat = (this.data.lndmLatitude || '').toString().trim();
      const lng = (this.data.lndmLongitude || '').toString().trim();
      return !!(name && type && lat && lng);
    },
    coordinateValidationError() {
      const lat = this.parseCoordinate(this.data.lndmLatitude);
      const lng = this.parseCoordinate(this.data.lndmLongitude);
      return {
        lat: lat !== null && (lat < -90 || lat > 90) ? 'Latitude must be between -90 and 90.' : '',
        lng: lng !== null && (lng < -180 || lng > 180) ? 'Longitude must be between -180 and 180.' : '',
      };
    },
    hasCoordinateRangeError() {
      return !!(this.coordinateValidationError.lat || this.coordinateValidationError.lng);
    },
    filteredReferenceLandmarks() {
      const query = (this.referenceSearchQuery || '').trim().toLowerCase();
      if (!query) {
        return this.referenceLandmarks.slice(0, 10);
      }
      return this.referenceLandmarks
        .filter((landmark) => (landmark.lndmName || '').toLowerCase().includes(query))
        .slice(0, 10);
    },
  },
  mounted() {
    this.restoreDraft();
    this.$nextTick(() => {
      this.initMap();
    });
  },
  beforeDestroy() {
    if (this.map) {
      this.map.off();
      this.map.remove();
      this.map = null;
      this.marker = null;
    }
    if (this.referenceBlurTimeout) {
      clearTimeout(this.referenceBlurTimeout);
      this.referenceBlurTimeout = null;
    }
  },
  watch: {
    'data.lndmId': function dataLndmId() {
      if (!this.map) {
        this.$nextTick(() => {
          this.initMap();
        });
      } else {
        this.centerMapFromData();
      }
    },
    'data.lndmLatitude': function dataLndmLatitude(value) {
      this.syncMarkerFromInput(value, this.data.lndmLongitude);
      this.centerMapFromData();
    },
    'data.lndmLongitude': function dataLndmLongitude(value) {
      this.syncMarkerFromInput(this.data.lndmLatitude, value);
      this.centerMapFromData();
    },
    data: {
      deep: true,
      handler() {
        this.persistDraft();
      },
    },
  },
  methods: {
    parseCoordinate(value) {
      if (value === null || value === undefined || value === '') {
        return null;
      }
      const normalized = String(value).replace(',', '.').trim();
      if (!normalized) {
        return null;
      }
      const parsed = Number(normalized);
      return Number.isNaN(parsed) ? null : parsed;
    },
    sanitizeCoordinateInput(value) {
      const raw = String(value || '');
      let sanitized = raw.replace(/[^0-9,.-]/g, '');
      sanitized = sanitized.replace(/(?!^)-/g, '');
      const commaCount = (sanitized.match(/,/g) || []).length;
      const dotCount = (sanitized.match(/\./g) || []).length;
      if (commaCount + dotCount > 1) {
        let foundSeparator = false;
        sanitized = sanitized
          .split('')
          .filter((char) => {
            if (char !== ',' && char !== '.') return true;
            if (foundSeparator) return false;
            foundSeparator = true;
            return true;
          })
          .join('');
      }
      return sanitized;
    },
    onCoordinateTextInput(type) {
      const key = type === 'lat' ? 'lndmLatitude' : 'lndmLongitude';
      const currentValue = this.data[key];
      const sanitized = this.sanitizeCoordinateInput(currentValue);
      if (sanitized !== currentValue) {
        this.$set(this.data, key, sanitized);
      }
    },
    onReferenceInput() {
      this.showReferenceDropdown = true;
    },
    onReferenceBlur() {
      this.referenceBlurTimeout = setTimeout(() => {
        this.showReferenceDropdown = false;
      }, 120);
    },
    selectReferenceLandmark(landmark) {
      if (!landmark) {
        return;
      }
      this.referenceSearchQuery = landmark.lndmName || '';
      this.showReferenceDropdown = false;
      const lat = parseFloat(landmark.lndmLatitude);
      const lng = parseFloat(landmark.lndmLongitude);
      if (Number.isNaN(lat) || Number.isNaN(lng)) {
        return;
      }
      this.updateCoordinates(lat, lng);
      if (this.map) {
        this.map.setView([lat, lng], 14);
      }
    },
    onCancelAddClicked() {
      this.$emit('onCancelAddClicked');
    },
    onSubmitClicked() {
      if (!this.isFormComplete) {
        return;
      }
      if (this.hasCoordinateRangeError) {
        return;
      }
      if (this.isCreate) {
        sessionStorage.removeItem(this.draftStorageKey);
      }
      const data = { ...this.data };
      this.$emit('onSubmitClicked', data);
    },
    initMap() {
      if (this.map || !this.$refs.landmarkMap || typeof L === 'undefined') {
        return;
      }
      const lat = parseFloat(this.data.lndmLatitude) || this.defaultCenter[0];
      const lng = parseFloat(this.data.lndmLongitude) || this.defaultCenter[1];
      const map = L.map(this.$refs.landmarkMap).setView([lat, lng], this.defaultZoom);
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; OpenStreetMap contributors',
      }).addTo(map);
      this.map = map;
      this.markerIcon = L.icon({
        iconUrl: '/marker/pinpoint.png',
        iconSize: [32, 32],
        iconAnchor: [16, 32],
        popupAnchor: [0, -32],
      });
      this.setMarker(lat, lng);
      map.on('click', (event) => {
        if (!event || !event.latlng) {
          return;
        }
        const { lat: clickLat, lng: clickLng } = event.latlng;
        this.updateCoordinates(clickLat, clickLng);
      });
      setTimeout(() => {
        if (this.map) {
          this.map.invalidateSize();
        }
      }, 0);
    },
    centerMapFromData() {
      if (!this.map) {
        return;
      }
      const lat = parseFloat(this.data.lndmLatitude);
      const lng = parseFloat(this.data.lndmLongitude);
      if (Number.isNaN(lat) || Number.isNaN(lng)) {
        return;
      }
      this.map.setView([lat, lng], 12);
    },
    setMarker(lat, lng) {
      if (!this.map) {
        return;
      }
      const position = [lat, lng];
      if (this.marker) {
        this.marker.setLatLng(position);
      } else {
        this.marker = L.marker(position, {
          icon: this.markerIcon || undefined,
          draggable: true,
        }).addTo(this.map);
        this.marker.on('dragend', (event) => {
          const markerLatLng = event && event.target ? event.target.getLatLng() : null;
          if (!markerLatLng) {
            return;
          }
          this.updateCoordinates(markerLatLng.lat, markerLatLng.lng);
        });
      }
    },
    updateCoordinates(lat, lng) {
      const nextLat = Number(lat).toFixed(8);
      const nextLng = Number(lng).toFixed(8);
      this.$set(this.data, 'lndmLatitude', nextLat);
      this.$set(this.data, 'lndmLongitude', nextLng);
      this.setMarker(lat, lng);
    },
    syncMarkerFromInput(latValue, lngValue) {
      if (!this.map) {
        return;
      }
      const lat = parseFloat(latValue);
      const lng = parseFloat(lngValue);
      if (Number.isNaN(lat) || Number.isNaN(lng)) {
        return;
      }
      this.setMarker(lat, lng);
    },
    onCoordinateBlur(type) {
      const rawValue = type === 'lat' ? this.data.lndmLatitude : this.data.lndmLongitude;
      const value = String(rawValue).replace(',', '.').trim();
      if (value === '' || value === null || value === undefined) {
        return;
      }
      const parsed = Number(value);
      if (Number.isNaN(parsed)) {
        return;
      }
      const normalized = parsed.toFixed(8);
      if (type === 'lat') {
        this.$set(this.data, 'lndmLatitude', normalized);
      } else {
        this.$set(this.data, 'lndmLongitude', normalized);
      }
    },
    persistDraft() {
      if (!this.isCreate) {
        return;
      }
      const draft = {
        lndmName: this.data.lndmName || '',
        lndmType: this.data.lndmType || '',
        lndmDescription: this.data.lndmDescription || '',
        lndmLatitude: this.data.lndmLatitude || '',
        lndmLongitude: this.data.lndmLongitude || '',
      };
      sessionStorage.setItem(this.draftStorageKey, JSON.stringify(draft));
    },
    restoreDraft() {
      if (!this.isCreate) {
        return;
      }
      try {
        const rawDraft = sessionStorage.getItem(this.draftStorageKey);
        if (!rawDraft) {
          return;
        }
        const draft = JSON.parse(rawDraft);
        ['lndmName', 'lndmType', 'lndmDescription', 'lndmLatitude', 'lndmLongitude'].forEach((key) => {
          if (!this.data[key] && draft[key] !== undefined) {
            this.$set(this.data, key, draft[key]);
          }
        });
      } catch (error) {
        sessionStorage.removeItem(this.draftStorageKey);
      }
    },
  },
};
</script>

<style scoped>
.landmark-form-map {
  width: 100%;
  height: 280px !important;
  border-radius: 8px;
}

.reference-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  z-index: 1200;
  max-height: 240px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
}

.reference-item {
  width: 100%;
  text-align: left;
  border: 0;
  background: transparent;
  padding: 8px 12px;
  font-size: 13px;
}

.reference-item:hover {
  background: #f5f7fb;
}
</style>
